import { render, staticRenderFns } from "./BabyHeight.vue?vue&type=template&id=656c5494&scoped=true"
import script from "./BabyHeight.vue?vue&type=script&lang=js"
export * from "./BabyHeight.vue?vue&type=script&lang=js"
import style0 from "./BabyHeight.vue?vue&type=style&index=0&id=656c5494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c5494",
  null
  
)

export default component.exports